import { Skeleton } from '@mui/material';
import React from 'react';

const SkeletonGuestList = () => {
  return (
    <div>
      <Skeleton
        variant='rectangular'
        sx={{ bgcolor: 'grey.900', width: '100%', borderRadius: '5px', height: 168 }}
      />
    </div>
  );
};

export default SkeletonGuestList;
